export default  {
    name:'',
	min_sqft: null,
	max_sqft:null,
	notes: '',
	image: '',
	roof_pitch: '',
	total_height: '',
	masonry_percent: ''
}